<script lang="ts">
    import {authFetch} from "../Auth";
    import {strToLocaleDateTime} from "../Utils";
    import {getRouteById} from "../Nav";
    import {overlay} from "../Store";
    export const params = {}
    let list: any[] = []
    let count: number = 0
    let listPromise: Promise<any>
    let filter = {
        offset: 0,
        limit: 75,
        order: "DESC",
        orderBy: "id"
    }
    async function loadList() {
        let response = await authFetch('bot/list', {
            method: 'POST',
            body: JSON.stringify(filter),
        })
        if (response.ok) {
            let data = await response.json()
            list = data.list
            count = data.count
        } else {
            alert(response.statusText)
        }
    }

    function update(){
        listPromise = loadList()
    }
    update();
</script>
<table class="table table-bordered table-sm mt-3">
    <thead class="position-sticky bg-white shadow" style="z-index: 1030; top: 56px;">
    <tr style="border: 0px;">
        <th colspan="100">
            <div class="input-group justify-content-end">
                <button class="btn btn-info"
                        class:disabled={filter.offset===0}
                        on:click={()=>{filter.offset-=filter.limit;update()}}>
                    <i class="bi bi-chevron-left"></i>
                </button>
                <input class="form-control flex-grow-0" type="number" style="width: 5em;"
                       min="1"
                       max={Math.floor(count / filter.limit)+1}
                       step="1"
                       value={(filter.offset / filter.limit)+1}
                       on:change={(ev)=>{filter.offset=(ev.target.value - 1) * filter.limit; update()}}
                >
                <button class="btn btn-info disabled">
                    / {Math.floor(count / filter.limit)+1}
                </button>
                <button class="btn btn-info"
                        class:disabled={list.length < filter.limit}
                        on:click={()=>{filter.offset+=filter.limit;update()}}>
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </th>
        <tr style="font-size: 14px;">
            <th>ID</th>
            <th>TG ID</th>
            <th>Username</th>
            <th>Активний</th>
            <th>Початок роботи</th>
            <th>Дата бану</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
    {#await listPromise}
        <tr>
            <td colspan="1000" class="text-center">
                <div class="spinner-grow"></div>
            </td>
        </tr>
    {:then _}
        {#if list.length > 0}
            {#each list as app}
                <tr>
                    <td>{app.id}</td>
                    <td>{app.telegram_user_id}</td>
                    <td>{app.username ?? '-'}</td>
                    <td>{app.is_active ?? '0'}</td>
                    <td>{strToLocaleDateTime(app.start_used_at)}</td>
                    <td>{strToLocaleDateTime(app.banned_at)}</td>
                    <td>-</td>
                </tr>
            {/each}
        {:else}
            <tr>
                <td colSpan="1000" class="text-center">
                    <div class="alert alert-secondary">Немає акаунтів</div>
                </td>
            </tr>
        {/if}
    {/await}
    </tbody>
</table>